import { IIconProps } from '../../types/IconProps.interface'

export const IconPencil2 = ({ color = 'white', className }: IIconProps) => {
  return (
    <svg
      className={`w-full ${className}`}
      fill='none'
      viewBox='0 0 10 11'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5 10.0001H9.5M7.25 1.75011C7.44891 1.5512 7.7187 1.43945 8 1.43945C8.13929 1.43945 8.27721 1.46689 8.4059 1.52019C8.53458 1.57349 8.65151 1.65162 8.75 1.75011C8.84849 1.8486 8.92662 1.96553 8.97992 2.09422C9.03323 2.2229 9.06066 2.36083 9.06066 2.50011C9.06066 2.6394 9.03323 2.77733 8.97992 2.90601C8.92662 3.0347 8.84849 3.15162 8.75 3.25011L2.5 9.50011L0.5 10.0001L1 8.00011L7.25 1.75011Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
